import React from 'react';

import {Button} from '@kit';

import {cls} from '../../../../components/utils';
import {useCharacter} from '../character-context';
import type {DeathSaves} from '../model/character-state';
import {applyDeathSave, DEATH_SAVES_LIMIT, deathSaveOutcome} from '../model/death-saves';
import {D20} from '../model/dice';
import {useRoll} from './dice-roller';
import {Marks} from './marks';

import css from './sheet.module.css';

/** отметки и бросок испытания против смерти: в управлении ПЗ, когда ПЗ 0 */
export const DeathSavesPanel: React.FC = () => {
	const {state, character, update} = useCharacter();
	const roll = useRoll();

	const setDeathSaves = (kind: keyof DeathSaves, count: number) =>
		update((current) => ({deathSaves: {...current.deathSaves, [kind]: count}}));

	const rollDeathSave = () =>
		roll({
			title: 'Испытание против смерти',
			formula: D20,
			mode: character.rollAdvice({kind: 'deathSave'}).mode,
			onResult: (result) => {
				const outcome = deathSaveOutcome(result.groups[0]?.values[0] ?? 0, result.total);
				update((current) =>
					outcome === 'revive'
						? {
								deathSaves: {successes: 0, failures: 0},
								hitPoints: {...current.hitPoints, spent: Math.max(0, character.maxHitPoints - 1)},
						  }
						: {deathSaves: applyDeathSave(current.deathSaves, outcome)},
				);
			},
		});

	return (
		<section className={css.deathSavesPanel}>
			<h3 className={css.deathSavesTitle}>Испытания против смерти</h3>
			<div className={css.deathSaves}>
				<span>Успехи</span>
				<Marks
					total={DEATH_SAVES_LIMIT}
					filled={state.deathSaves.successes}
					label="Успехи"
					onChange={(count) => setDeathSaves('successes', count)}
				/>
				<span>Провалы</span>
				<Marks
					total={DEATH_SAVES_LIMIT}
					filled={state.deathSaves.failures}
					label="Провалы"
					danger
					onChange={(count) => setDeathSaves('failures', count)}
				/>
			</div>
			<Button appearance="primary" onClick={rollDeathSave}>
				Бросить
			</Button>
		</section>
	);
};

type DeathSaveMarksProps = {
	/** мелкие точки для строки показателей */
	small?: boolean;
};

/** состояние испытаний против смерти вместо ПЗ на листе: только показ */
export const DeathSaveMarks: React.FC<DeathSaveMarksProps> = ({small}) => {
	const {state} = useCharacter();
	return (
		<span className={cls(css.deathSaveMarks, small && css.deathSaveMarksSmall)}>
			<Marks total={DEATH_SAVES_LIMIT} filled={state.deathSaves.successes} label="Успехи" small={small} />
			<Marks total={DEATH_SAVES_LIMIT} filled={state.deathSaves.failures} label="Провалы" danger small={small} />
		</span>
	);
};
